import { CampaignDto } from '@shelflix/trpc/routes/campaign/list/useCase';
import { CurrentCampaigns } from '../CurrentCampaigns';
import { DefaultCampaigns } from '../DefaultCampaigns';
import { ScheduledCampaigns } from '../ScheduledCampaignsMobile';

interface ScheduleCampaign {
  campaign: CampaignDto;
  startDate: string;
  endDate: string;
  isPaused?: boolean;
}

interface CampaignsSectionProps {
  defaultCampaign?: CampaignDto | null;
  scheduledCampaigns: ScheduleCampaign[];
  currentCampaign?: CampaignDto | null;
  showCurrentCampaign?: boolean;
  onPauseCampaign?: (campaignUuid: string, isPaused: boolean) => void;
  onPlayCampaignNow?: (campaignUuid: string) => void;
  onRemoveCurrentCampaign?: (campaign: CampaignDto) => void;
  handleShowModalAvailableCampaign?: (props: {
    title: string;
    icon: string;
    type: 'play_now' | 'scheduled' | 'default';
  }) => void;
}

export function CampaignsSection({
  defaultCampaign,
  scheduledCampaigns,
  currentCampaign,
  showCurrentCampaign = false,
  onPauseCampaign,
  onPlayCampaignNow,
  onRemoveCurrentCampaign,
}: CampaignsSectionProps) {
  return (
    <div className="mt-0 flex w-full flex-col items-center space-y-6">
      <div className="mt-4 w-full px-2">
        {showCurrentCampaign && (
          <CurrentCampaigns
            currentCampaign={currentCampaign}
            defaultCampaign={defaultCampaign}
            scheduledCampaigns={scheduledCampaigns}
          />
        )}
      </div>
      <div className="w-full space-y-4">
        <ScheduledCampaigns
          scheduledCampaigns={scheduledCampaigns
            .filter((item) => item.campaign.uuid !== currentCampaign?.uuid)
            .filter((item) => new Date(item.startDate) > new Date())
            .map((item) => ({
              campaign: item.campaign,
              thumbnailUrl: item.campaign.thumbnailUrl || '',
              startDate: item.startDate,
              isPaused: item.isPaused,
            }))}
          onPlayCampaignNow={onPlayCampaignNow}
        />
      </div>

      <div className="mt-4 w-full px-2">
        {defaultCampaign && (
          <DefaultCampaigns
            onPauseCampaign={onPauseCampaign}
            currentCampaign={currentCampaign}
            defaultCampaign={defaultCampaign}
            onRemoveCurrentCampaign={onRemoveCurrentCampaign}
          />
        )}
      </div>
    </div>
  );
}
